var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element"},[(!_vm.hasLoaded)?_c('loader'):_vm._e(),_c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"chart"}),_c('div',{staticClass:"footer"},[_c('range',{attrs:{"from":_vm.from,"to":_vm.to}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }